export default __webpack_public_path__ + "static/media/02n.9661376d.png";